"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarFocusDelegate = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
class ToolbarFocusDelegate {
  toolbarRoot = null;
  overflowPortalRoot = null;

  /**
   * Call this when the root element is ready (with a callback ref, usually). This function stores
   * the root element and you can call refreshFocusables() to update the list of focusables.
   * @param rootElement the element to search for focusable elements within.
   */
  setToolbarRootElement(rootElement) {
    this.toolbarRoot = rootElement;
  }
  setOverflowPortalRootElement(overflowPortalRoot) {
    this.overflowPortalRoot = overflowPortalRoot;
  }

  /**
   * Returns the element visually before the given one, or `null` for none.
   */
  getElementBefore(element) {
    const focusables = this.getVisibleFocusables();
    const thisElementIndex = focusables.indexOf(element);
    if (thisElementIndex === -1) {
      return null;
    }
    return focusables[thisElementIndex - 1] || null;
  }

  /** Returns the element visually after the given one, or `null` for none. */
  getElementAfter(element) {
    const focusables = this.getVisibleFocusables();
    const thisElementIndex = focusables.indexOf(element);
    if (thisElementIndex === -1) {
      return null;
    }
    return focusables[thisElementIndex + 1] || null;
  }

  /**
   * Returns the first element, or `null` for none.
   */
  getFirstElement() {
    const focusables = this.getVisibleFocusables();
    return focusables[0] || null;
  }

  /**
   * Returns the last element, or `null` for none.
   */
  getLastElement() {
    const focusables = this.getVisibleFocusables();
    return focusables[focusables.length - 1] || null;
  }
  getFirstEnabledElement() {
    const focusables = this.getVisibleFocusables();
    return focusables.find(element => {
      return (!element.ariaDisabled || element.ariaDisabled === "false") && !element.disabled;
    }) || null;
  }
  focusablesInclude(elem) {
    return this.getVisibleFocusables().includes(elem);
  }
  getVisibleFocusables() {
    const mainToolbarButtons = this.toolbarRoot ? (0, _lodestarUtils.getKeyboardFocusableElementsIn)(this.toolbarRoot) : [];
    const overFlowMenuVisible = this.overflowPortalRoot && getComputedStyle(this.overflowPortalRoot).opacity === "1";
    const portalButtons = this.overflowPortalRoot && overFlowMenuVisible ? (0, _lodestarUtils.getKeyboardFocusableElementsIn)(this.overflowPortalRoot) : [];
    return [...mainToolbarButtons, ...portalButtons];
  }
}
exports.ToolbarFocusDelegate = ToolbarFocusDelegate;
//# sourceMappingURL=ToolbarFocusDelegate.js.map